"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchShoppingContextData = void 0;
var _checkoutUtils = require("@ori/checkout-utils");
var _types = require("../types");
var _utils = require("../utils");
/**
 * Returns aggregated shopping context data, currently via legacy "AJAX" Online endpoint.
 * TODO: Replace with GraphQL.
 */
const fetchShoppingContextData = async () => {
  const response = await fetch(_types.RequestUrl.GetShoppingContext, (0, _utils.getHttpRequestSettings)(undefined, _checkoutUtils.HttpMethod.Post));
  return (0, _utils.convertToCamelCase)(await response.json());
};
exports.fetchShoppingContextData = fetchShoppingContextData;